import api, { unwrap } from './client';
import type { ErpModule } from '@/api/platform.api';
import type { ApiResponse } from '@/types/api';

export interface GlobalSearchResult {
  type: string;
  id: number;
  title: string;
  subtitle?: string;
  path: string;
  module: string;
}

export const searchApi = {
  /** Entity search scoped to the active module when provided. */
  global: (q: string, module?: ErpModule | null) =>
    unwrap(
      api.get<ApiResponse<GlobalSearchResult[]>>('/v1/platform/search', {
        params: { q, ...(module ? { module } : {}) },
      }),
    ),
};
